import { DateTime } from 'luxon';
import { OneDayInMillis } from './time';

export { PRICING_VERSIONS } from '@racemap/sdk/schema/billing';

import { PRICING_VERSIONS } from '@racemap/sdk/schema/billing';

export const DEVICE_TIMEOUT = 6 * OneDayInMillis;
export const TRACKER_MANAGEMENT_BILLING_CYCLE = 30 * OneDayInMillis;

// Change that value, to renew all subscriptions of the users. Cancel the old subscriptions. Should happen
// shortly after billing cycle or with some time before the end. Is helpful, if a lot of user have more than
// 20 products on the subscription plan.
export const CURRENT_SUBSCRIPTION_VERSION = '2025-01';

// TODO: use correct start and endate
export const PRICING_VERSION_TABLE = {
  [PRICING_VERSIONS.V2016_01]: {
    from: DateTime.fromISO('2016-01-01T00:00:00Z'),
    to: DateTime.fromISO('2019-08-01T00:00:00Z'),
    numDaysEventCycle: 90,
  },
  [PRICING_VERSIONS.V2019_08]: {
    from: DateTime.fromISO('2019-08-01T00:00:00Z'),
    to: DateTime.fromISO('2020-09-01T00:00:00Z'),
    numDaysEventCycle: 90,
  },
  [PRICING_VERSIONS.V2020_09]: {
    from: DateTime.fromISO('2020-09-01T00:00:00Z'),
    to: DateTime.fromISO('2024-08-01T00:00:00Z'),
    numDaysEventCycle: 90,
  },
  [PRICING_VERSIONS.V2024_08]: {
    from: DateTime.fromISO('2024-08-01T00:00:00Z'),
    to: null,
    numDaysEventCycle: 7,
  },
};

export const TRACKER_RENT_AND_BUY_BREAKS = [4, 19, 39, 99];
